<template>
  <span>
    <span :id="`rich-tooltip-${_uid}`" class="rich-tooltip-trigger" @click="!target && $event.stopPropagation()"><feather-icon icon="InfoIcon" size="16" /></span>
    <b-popover :target="target_id" :show.sync="show" triggers="hover" :placement="placement" custom-class="rich-tooltip-popover">
      <p v-if="header" class="rich-tooltip-header">{{ header }}</p>
      <div class="d-flex">
        <div class="rich-tooltip-icon"><feather-icon :icon="icon" size="18" /></div>
        <div>
          <h6 v-if="title" class="rich-tooltip-title">{{ title }}</h6>
          <p class="rich-tooltip-text">{{ text }}</p>
        </div>
      </div>
    </b-popover>
  </span>
</template>

<script>
import { BPopover } from 'bootstrap-vue';

export default {
  name: 'RichTooltip',
  components: {
    BPopover,
  },
  props: {
    header: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: 'InfoIcon'
    },
    placement: {
      type: String,
      default: 'bottom'
    },
    // Id of an outer element to use as the hover area instead of the icon
    target: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      show: false,
    }
  },
  computed: {
    target_id() {
      return this.target || `rich-tooltip-${this._uid}`;
    }
  },
  mounted() {
    document.addEventListener('click', this.hideOnTargetClick, true);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.hideOnTargetClick, true);
  },
  methods: {
    // Clicking the target opens the edit sidebar, which covers the page so mouseleave never fires
    hideOnTargetClick(event) {
      const target = document.getElementById(this.target_id);
      if (target && target.contains(event.target)) this.show = false;
    },
  },
}
</script>
<style scoped lang="scss">
.rich-tooltip-trigger {
  display: inline-flex;
  vertical-align: middle;
  margin-left: 0.4em;
  color: inherit;
  cursor: help;
  opacity: 0.8;
}
.rich-tooltip-trigger:hover {
  opacity: 1;
}
</style>
<style lang="scss">
.rich-tooltip-popover {
  max-width: 320px;
  border: none;
  border-radius: 1em;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.12);
  .popover-body {
    padding: 1em 1.1em;
  }
  .rich-tooltip-header {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #8a8f98;
    margin-bottom: 0.75em;
  }
  .rich-tooltip-icon {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    margin-right: 0.85em;
    border-radius: 0.6em;
    background: #2969c81e;
    color: #2969C8;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .rich-tooltip-title {
    font-weight: 700;
    color: #1f2329;
    margin-bottom: 0.25em;
    line-height: 1.3;
  }
  .rich-tooltip-text {
    font-size: 13px;
    color: #5c6370;
    line-height: 1.45;
    margin: 0;
  }
}
</style>
